const BILLING_PAGES = {
  overview: 'overview',
  plans: 'plans',
  packages: 'packages',
  history: 'history',
  payment: 'payment',
  referral: 'refer-and-earn',
  cancelPlan: 'cancel-plan',
} as const;

export default BILLING_PAGES;
